import React from 'react';

import OfferFilterDatesList from 'components/Offers/Filters/FilterDatesList';

import FilterScreenMobile from './FilterScreenMobile';

const DatesMobile = () => {
  return (
    <FilterScreenMobile title="DATES">
      <OfferFilterDatesList />
    </FilterScreenMobile>
  );
};
export default DatesMobile;
